<template>
<div class="app-frame">
  <slot></slot>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from './config.js';
import { mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState([
      'user'
    ])
  },

  methods: {
    ...mapMutations([
      'setUser'
    ])
  },

  mounted(){
    firebase.auth().onAuthStateChanged(user =>{
      if(user){
        console.log("user signed in");
      }else{
        console.log("user signed out");
      }

      this.setUser(user);
    });
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?4b985efa